import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-toggleswitch',
  templateUrl: './adc-toggleswitch.component.html',
  styleUrls: ['./adc-toggleswitch.component.scss'],
  standalone: false
})
export class AdcToggleswitchComponent {
  @Input('data') data: any;
  @Input('type') type: any;
  @Output() toggleEvent: EventEmitter<boolean> = new EventEmitter<boolean>;

  checkboxEvent(event: any) {
    this.toggleEvent.emit(event.target.checked);
  }
}
